"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ticksToBPM = exports.quarternoteToBPM = exports.averageIntervals = exports.computeIntervalsInMs = void 0;
const sum = (a, b) => a + b;
const computeIntervalsInMs = (ticks) => {
    const results = [];
    for (let i = 1; i < ticks.length; i++) {
        results.push(ticks[i] - ticks[i - 1]);
    }
    return results;
};
exports.computeIntervalsInMs = computeIntervalsInMs;
const averageIntervals = (differences) => {
    if (!differences || !differences.length) {
        return 0;
    }
    return differences.reduce(sum) / differences.length;
};
exports.averageIntervals = averageIntervals;
const quarternoteToBPM = (interval) => {
    return 60000 / (interval * 24);
};
exports.quarternoteToBPM = quarternoteToBPM;
const ticksToBPM = (ticks) => {
    if (!ticks || ticks.length < 2) {
        return 0;
    }
    return (0, exports.quarternoteToBPM)((0, exports.averageIntervals)((0, exports.computeIntervalsInMs)(ticks)));
};
exports.ticksToBPM = ticksToBPM;
